export default function SpepInstructionCard({
  title,
  detail,
  "data-testid": dataTestId
}: {
  title: string;
  detail: string;
  "data-testid"?: string;
}) {
  return (
    <div
      className="linking-group--right--content__instruction"
      data-testid={dataTestId}
    >
      <p className="flex items-strech">
        <b className="mr-1 min-w-[60px]">{title}</b>{" "}
        <span className="grow">{detail}</span>
      </p>
    </div>
  );
}
